import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { LoginModule } from './module/login/login.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './shared/interceptors/tokenInterceptor';
import { ApiModule } from './api/dynamic-form/api.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  exports: [ToastrModule],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 1000,
    }),
    LoginModule,
    ApiModule.forRoot({ rootUrl: environment.apiUrlDynamicForm }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
